<div>
  <img class="media" [src]="post?.media_url">
</div>
